var steps = {
    title: 'Semway Gamification',
  steps: [
        {
            type: 'TextRange',      
            text: "Ranger deg selv. Hvor kreativ er du?",
            start: 'Not at all',
            end:'Superduper',
            responses: [
              {text: 'Svært lite', value: 0, points: 0 },
              {text: 'Kanskje litt', value: 1, points: 1 },
              {text: 'Middels', value: 2, points: 2},
              {text: 'Ganske kreativ', value: 3, points: 3},
              {text: 'Sjukt kreativ', value: 4, points: 4},
            ]
      },
      {
        type: 'TextRange',      
        text: "Hvor godt liker du å fordype deg i tall og data?",
        start: 'Not at all',
        end:'Superduper',
        responses: [
            
          {text: 'Svært lite', value: 0, points: 0 },
          {text: 'Kanskje litt', value: 1, points: 1 },
          {text: 'Enten eller', value: 2, points: 2},
          {text: 'Skikkelig godt', value: 3, points: 3},
          {text: 'Elsker det!', value: 4, points: 4},
          
        ]
      },
      {
        type: 'TextRange',      
        text: "Hvor god er du til å produsere innhold?",
        start: 'Not at all',
        end:'Superduper',
        responses: [
            
          {text: 'Not at all', value: 0, points: 0 },
          {text: 'Vel.. litt', value: 1, points: 1 },
          {text: 'Midt på treet', value: 2, points: 2},
          {text: 'Temmelig god!', value: 3, points: 3},
          {text: 'Awesome!', value: 4, points: 4},
          
        ]
        },
    {
        type: 'Question',      
        text: "Hva står SEO for?",
        responses: [
          {text: 'Service elevator operator', value: 4, points: 0},
          {text: 'Search engine optimization', value: 3, points: 1},
          {text: 'Search engeneer operator', value: 2, points: 0},
          {text: 'Search engine octopus', value: 1, points: 0},
        ]
        },
        {
            type: 'Question',      
            text: "Hva betyr UX?",
            responses: [
              {text: 'Unique X', value: 4, points: 0},
              {text: 'User xang', value: 1, points: 0},
              {text: 'Unique experience', value: 2, points: 0},
              {text: 'User experience', value: 3, points: 1},
            ]
            },
            {
                type: 'Question',      
                text: "Hva betyr CPC?",
                responses: [
                  {text: 'Channel preferred cost', value: 4, points: 0},
                  {text: 'Cost per click', value: 3, points: 1},
                  {text: 'Click payment channel', value: 2, points: 0},
                  {text: 'Crazy people channel', value: 1, points: 0},
                ]
    },
    {
      type: 'DragDrop',      
      text: "Hvilket ord hører hjemme her? Dra riktig ord inn i boksen.",
      box: "Annonseverktøyet til Facebook heter ",
      start: 'Not at all',
      end:'Superduper',
      responses: [
        {text: 'Facebook Business Manager', value: 0, points: 0 },
        {text: 'Facebook Ad Tool', value: 1, points: 0 },
        {text: 'Facebook Advertising', value: 2, points: 1},
      ]
},{
  type: 'DragDrop',      
  text: "Hvilket ord hører hjemme her? Dra riktig ord inn i boksen.",
  box: "Verdens største nettsideplattform er ",
  start: 'Not at all',
  end:'Superduper',
  responses: [
    {text: 'Squarespace', value: 0, points: 0 },
    {text: 'Shopify', value: 1, points: 0 },
    { text: 'Wordpress', value: 2, points: 1 },
    {text: 'Craft', value: 3, points: 0},
  ]
},{
  type: 'DragDrop',      
  text: "Hvilket ord hører hjemme her? Dra riktig ord inn i boksen.",
  box: "Analyseverktøyet til Google heter ",
  start: 'Not at all',
  end:'Superduper',
  responses: [
    {text: 'Google 180', value: 0, points: 0 },
    {text: 'Google Analytics', value: 1, points: 1 },
    { text: 'Google Smart', value: 2, points: 0 },
    {text: 'Google Numbers', value: 3, points: 0},
  ]
}
  ]
};
  
export default steps;


// WEBPACK FOOTER //
// ./src/appdata/steps.js